var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeedling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6dd627",
    d: "M47 9.06a14.54 14.54 0 0 0-7.78-1.76c-4.22.36-6.78 4.53-5.22 7.61a16 16 0 0 0-1.79 1.9a22.9 22.9 0 0 0-4.5 11.52l2 4s.41-7.66 3.5-13a27 27 0 0 1 1.93-2.89c2.88 2.76 6.7.08 8.59-2.12a40 40 0 0 1 3.44-3.62A1 1 0 0 0 47 9.06"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ceb60",
    d: "M39.22 9.53a14.44 14.44 0 0 1 7.46 1.62c.17-.17.34-.33.49-.46A1 1 0 0 0 47 9.06a14.54 14.54 0 0 0-7.78-1.76c-3.83.33-6.29 3.8-5.53 6.74a6.2 6.2 0 0 1 5.53-4.51m-7.01 9.52A15 15 0 0 1 34 17.14a4.2 4.2 0 0 1-.46-1.79a18 18 0 0 0-1.33 1.46a22.9 22.9 0 0 0-4.5 11.52l.24.48a22.6 22.6 0 0 1 4.26-9.76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M47 9.06a14.54 14.54 0 0 0-7.78-1.76c-4.22.36-6.78 4.53-5.22 7.61a16 16 0 0 0-1.79 1.9a22.9 22.9 0 0 0-4.5 11.52l2 4s.41-7.66 3.5-13a27 27 0 0 1 1.93-2.89c2.88 2.76 6.7.08 8.59-2.12a40 40 0 0 1 3.44-3.62A1 1 0 0 0 47 9.06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#45413c",
    d: "M17.35 46.39a11.52 1.61 0 1 0 23.04 0a11.52 1.61 0 1 0-23.04 0",
    opacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6dd627",
    d: "M27.71 22.82A29.2 29.2 0 0 0 19.86 12c.34-2.15.65-8-5.35-10.42C9-.68 3.51 1.15 1.1 2.23a1 1 0 0 0-.33 1.59a34.5 34.5 0 0 1 4.67 6.4c3.06 5.43 9.62 8.68 13.83 3.16a26.2 26.2 0 0 1 5.43 10.44c3.51 12.94 1.69 18.47.9 20.61a1.42 1.42 0 0 0 .59 1.71a5.3 5.3 0 0 0 2.52.71c2.35.1 2.5-1.5 2.5-1.5a52.1 52.1 0 0 0-3.5-22.53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9ceb60",
    d: "M20 14.21a27 27 0 0 1 1.67 2.39a28.2 28.2 0 0 1 6.09 9.14a52.6 52.6 0 0 1 3.61 17.78a53 53 0 0 0-3.61-20.7A29.2 29.2 0 0 0 20 12.1a12 12 0 0 1 0 2.11M1.72 4.89C4.36 3.82 9.4 2.41 14.51 4.5a8.32 8.32 0 0 1 5.41 7c.29-2.42.21-7.68-5.41-10s-11-.42-13.41.66a1 1 0 0 0-.33 1.66c.23.3.59.65.95 1.07"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M27.71 22.82A29.2 29.2 0 0 0 19.86 12c.34-2.15.65-8-5.35-10.42C9-.68 3.51 1.15 1.1 2.23a1 1 0 0 0-.33 1.59a34.5 34.5 0 0 1 4.67 6.4c3.06 5.43 9.62 8.68 13.83 3.16a26.2 26.2 0 0 1 5.43 10.44c3.51 12.94 1.69 18.47.9 20.61a1.42 1.42 0 0 0 .59 1.71a5.3 5.3 0 0 0 2.52.71c2.35.1 2.5-1.5 2.5-1.5a52.1 52.1 0 0 0-3.5-22.53"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6dd627",
    stroke: "#45413c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M35 14.52s.94-4.63 7-4.51M18 11c-.31-5.32-7.51-6.5-7.51-6.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedling);
export default __webpack_public_path__ + "static/media/seedling.4ace1620817d820b7fead0b34f0d5d1d.svg";
export { ForwardRef as ReactComponent };